var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da1f26;}.cls-2{fill:#f1582a;}.cls-3{fill:#231f20;fill-rule:evenodd;}.cls-4{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,38c0-8,0-16.08,0-24.13C.06,5.45,6.44-.09,15.4,0,29,.13,42.33,2,55.79,3.12c2.94.24,5.88.41,8.81.76,6.69.8,12,6,12.13,12.34.2,14.53.24,29.07,0,43.6C76.65,65.3,72,71.63,64.4,72.24q-16.15,1.29-32.29,2.9c-6.78.68-13.56,1.38-20.34.58A13.29,13.29,0,0,1,.05,63.07C0,54.72,0,46.37,0,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.48,38c0-8,0-16.07,0-24.11C4.53,5.5,10.54,0,19,.05,31.74.18,44.34,2.05,57,3.16c2.76.25,5.54.42,8.29.77A12.86,12.86,0,0,1,76.74,16.25c.18,14.53.23,29.06,0,43.58A13,13,0,0,1,65.13,72.24q-15.22,1.29-30.42,2.9c-6.38.67-12.76,1.37-19.15.57a13,13,0,0,1-11-12.64c-.09-8.34,0-16.69,0-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.71,37.24l4.18,6.88a2,2,0,0,1-.26,2.16L30.88,61.45c-2.74,3.82-7-.43-3.73-5.77,0,0,9.56-17.6,9.87-18.24A.92.92,0,0,1,38.71,37.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.59,65.35c.28.09.41,0,.38-.21q-3.6-5.53-6.78-11.3c.06-.49.29-.62.72-.39l7.31,11c.29.1.42,0,.43-.23L41.13,52.78c0-.5.26-.63.7-.38L48.7,63.67c.28.11.44,0,.46-.25L43.1,51.66c0-.45.29-.59.76-.42Q47.54,57,50.51,62.62c.25.09.38,0,.41-.22q-2.47-6.28-5.45-12.26a20.56,20.56,0,0,0-1.85-3.26,5.07,5.07,0,0,0-2.56-.81,5,5,0,0,1-2.69-1.14,80.07,80.07,0,0,1-4.92-11,81.75,81.75,0,0,0-8-16.63c-1.46-1.84-2.88-2.51-4.24-2q-1.89,1.21-.52,4.49a114.52,114.52,0,0,0,9.64,15.84Q33.8,40.69,36.72,46a4,4,0,0,1-.42,2.52,4.44,4.44,0,0,0-.62,2.76,16.81,16.81,0,0,0,1.76,3.23,92.26,92.26,0,0,0,8.15,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.63,15.26,62.08,59.07a1.56,1.56,0,0,1-1,2.38c-5,1.55-6.21-2.69-8-5.2L38.79,32a.47.47,0,0,0-.82,0c-.49.52-9,8.59-9,8.59-4.11,4.2-8.91,2.35-7.79,0l6.81-10c5.22-8-.59-6.57-.92-17.38a2.45,2.45,0,0,1,2.92-2.76s5.24,1.11,7.38,1.48C40.21,12.2,41.63,15.26,41.63,15.26Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRest);
export default __webpack_public_path__ + "static/media/rest.a9a14fcf946735a855e018af75ee0bcb.svg";
export { ForwardRef as ReactComponent };